"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgClock = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M.76 12c0-6.627 5.373-12 12-12 6.625.007 11.994 5.376 12 12 0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12zm15.788 5.283c.41.364 1.036.337 1.413-.062v.001a1 1 0 00-.066-1.414L13.26 11.56V6.5a1 1 0 10-2 0V12a1 1 0 00.328.737l4.959 4.546z", clipRule: "evenodd" })));
};
exports.default = SvgClock;
//# sourceMappingURL=Clock.js.map